export const STORE_QUEUE_SCRAP = 'storeQueueScrap';
export const GET_DATA_CERT_DETRAN = 'getDataCertDetran';
